import { configureStore } from '@reduxjs/toolkit';
import {
  UnmappedHealthPlanNamesReducer,
  PayerAddressListReducer,
  HealthPlanTypeListReducer,
  ScenariosListReducer,
} from './GetDropDownsValuesReducer';
import {
  HealthPlanMappingItemReducer,
  HealthPlanMappingReducer,
  HealthPlanPageNumberItemReducer,
} from './HealthPlanMappingReducer';
import {
  HealthPlanMasterItemReducer,
  HealthPlanMasterReducer,
} from './HealthPlanMasterReducer';
import { PayerAddressItemReducer } from './PayerAddressReducer';
import { UserDetailsReducer, UsersListReducer } from './UserDetailsReducer';
import { HealthPlanTypeItemReducer } from './HealthPlanTypeReducer';
import { PayerMasterItemReducer, PayerMasterReducer } from './PayerMasterReducer';
import { GetFormDropdownListReducer, IdentifierInscoListReducer, OverridesListReducer, ScenariosItemReducer } from './ScenariosReducer';
import { HIMInventoryItemReducer, HIMInventoryListReducer } from './HIMInventoryReducer';
import { FacilityListReducer } from './RRDInventoryReducer';

export const Store = configureStore({
  reducer: {
    healthPlanPayerMappedList: HealthPlanMappingReducer,
    setHealthPlanMappingItem: HealthPlanMappingItemReducer,
    unmappedHealthPlanList: UnmappedHealthPlanNamesReducer,
    setHealthPlanPageNumber: HealthPlanPageNumberItemReducer,
    payerAddressList: PayerAddressListReducer,
    healthPlanMasterList: HealthPlanMasterReducer,
    setHealthPlanMasterItem: HealthPlanMasterItemReducer,
    healthPlanTypeList: HealthPlanTypeListReducer,
    scenariosList: ScenariosListReducer,
    payerAddressItem: PayerAddressItemReducer,
    userdetails: UserDetailsReducer,
    setHealthPlanTypeItem: HealthPlanTypeItemReducer,
    setPayerMasterItem: PayerMasterItemReducer,
    payerMasterList: PayerMasterReducer,
    setScenariosItem: ScenariosItemReducer,
    IdentifierInscoReducer: IdentifierInscoListReducer,
    getFormDropdownList: GetFormDropdownListReducer,
    overridesList: OverridesListReducer,
    HIMInventoryItem: HIMInventoryItemReducer,
    HIMInventoryList: HIMInventoryListReducer,
    facilityDetailList: FacilityListReducer,
    usersList: UsersListReducer
  },
});

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
